import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/appsumo/as-Select-dark.png")